module.exports = __webpack_public_path__ + "media/video_call.9a2c246c.mp3";